import ApiService from '@/common/api.service'
import { getDataVersion } from '../utils'

/* eslint-disable */
const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
  fetchPresetRegionEthnicities(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(ctx.rootState)
      ApiService.get('PresetEthnicity/pagination', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  
  fetchPresetRegionEthnicity(context, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetEthnicity/${queryParams.id}`, queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  savePresetRegionEthnicity(ctx, queryParams) {
    return new Promise((resolve, reject) => {
      queryParams.dataVersion = getDataVersion(ctx.rootState)
      ApiService.post('PresetEthnicity', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  removePresetRegionEthnicity(context, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.get(`PresetEthnicity/delete/${queryParams.id}`, {}, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
